module.exports = __webpack_public_path__ + "img/1489091952.0021cb85.jpg";